import React from 'react';

export default function HeartIcon(){
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33193 14.7589C6.94184 16.1919 8.65691 17.4977 10.4644 18.6654L11 19L11.5291 18.6692C13.3395 17.5014 15.0574 16.1939 16.6681 14.7588C20.206 11.5784 22 8.65445 22 6.06824C22 4.32183 21.2552 2.65921 19.9556 1.5078C18.6551 0.355412 16.9266 -0.175928 15.2118 0.0516623C13.4969 0.278282 11.9624 1.24069 11 2.69194C10.0375 1.24061 8.50296 0.278215 6.78816 0.0516623C5.07321 -0.17592 3.34486 0.355436 2.04439 1.5078C0.744809 2.65923 0 4.32163 0 6.06824C0 8.6547 1.79423 11.5785 5.33193 14.7589Z"
        fill="#FDA29B"
      />
    </svg>
  );
}